import React from "react";

//Components
import EtaTable from '../etaTable'
const EtaExpired = (props) => {

    return (
        <div>
            <EtaTable {...props} expiredMode={true}/>
        </div>
    )
}

export default EtaExpired